import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { BackendAccountService } from '../../services/backend-account.service';
import { IAgencyModel } from '../../models/account/IAgency.model';
import * as AgencyAction from '../../actions/account/actions-agency';
import { AgencyActions } from '../../actions/account/actions-agency';
import { getCustomerConfigInfo } from '../../reducers';
import { select, Store } from '@ngrx/store';

@Injectable()
export class EffectsAgency {
  getAgency$: Observable<AgencyActions> = createEffect(() => {
    return this.actions$.pipe(
      ofType<AgencyAction.GetAgency>(AgencyAction.GET_AGENCY),
      withLatestFrom(this.store.pipe(select(getCustomerConfigInfo))),
      switchMap(([, /* action */ customerConfigState]) =>
        this.backendAccountService
          .getAgency(customerConfigState.customerConfig.default_store_code)
          .pipe(map((data: IAgencyModel) => new AgencyAction.GetAgencySuccess(data)))
      )
    )
  });

  constructor(
    private readonly store: Store<any>,
    private readonly actions$: Actions,
    private readonly http: HttpClient,
    private readonly backendAccountService: BackendAccountService
  ) { }
}
